import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import axios from "axios";

import SupportingDocument from "@safecv/common/Components/MultiUpload/SupportingDocument";
// import BulkUploadForm from "./BulkUploadForm";

import {
  getDocumentTypes,
  fetchAdditionalDocuments,
} from "@safecv/actions/postActions";
import API_CONFIG from "@safecv/src/api-config";
import MESSAGE from "@safecv/shared/message";
import toast from "@safecv/shared/toast";

import Cross from "@safecv/assets/Images/cross.png";

function UploadModal(props) {
  const [uploadedAddDocs, setUploadedAddDocs] = useState([]);

  useEffect(() => {
    props.getDocumentTypes();
  }, []);

  const submitAddDocs = () => {
    let supportDocNameValues = [];
    let supportDocNameDuplicates = false;

    uploadedAddDocs.forEach((file) => {
      supportDocNameValues.push(file.name);
    });

    let supportDocNameUniqueValue = [...new Set(supportDocNameValues)];
    if (supportDocNameUniqueValue.length < uploadedAddDocs.length)
      supportDocNameDuplicates = true;

    if (supportDocNameDuplicates)
      toast.error(MESSAGE.ERROR_MESSAGE.ADDPLAN.DUPLICATE_DOCUMENT_NAME);
    else {
      toast.info(MESSAGE.ADDITIONAL_DOCS_START);
      // form data for supporting doc
      let docTypeOthers = props.documentTypes.filter(
        (type) => type.documentTypes.toLowerCase() === "others"
      )[0];

      let requests = uploadedAddDocs.map((file) => {
        return new Promise((resolve) => {
          var formDataSupportDoc = new FormData();
          formDataSupportDoc.append("file", file);
          formDataSupportDoc.append("documentId", docTypeOthers.id);
          formDataSupportDoc.append("documentName", file.name);
          formDataSupportDoc.append("jobId", props.jobId);
          formDataSupportDoc.append("documentExtension", file.type);
          axios
            .post(
              API_CONFIG.API_ROOT + "safecv/api/v1/supportdoc",
              formDataSupportDoc,
              {
                headers: { "Content-Type": "multipart/form-data" },
              }
            )
            .then((res) => {
              if (res.status && res.status === 200) {
                resolve();
              } else throw res;
            })
            .catch(() => {
              // to show error for specific document
              toast.error(MESSAGE.errorAdditionalDocUpload(file.name));
            });
        });
      });

      // to show additional document uploaded success
      requests.length &&
        Promise.all(requests).then(() => {
          toast.success(MESSAGE.ADDITIONAL_DOCS_SUCCESS);
          props.fetchAdditionalDocuments(props.jobId);
        });

      props.handleModalClose();
    }
  };

  return (
    <div className="modal-stamp">
      <header>
        <span className="stamp-header-title">Upload Additional Documents</span>
        <span onClick={props.handleModalClose} className="pointer-css">
          <img src={Cross} alt="Close icon" />
        </span>
      </header>
      <div>
        <SupportingDocument
          setUploadedAddDocs={setUploadedAddDocs}
          fromModal={true}
        />
        <footer className="supportDocFooter">
          <label className="cancelButton" onClick={props.handleModalClose}>
            Cancel
          </label>
          <button
            disabled={!uploadedAddDocs.length}
            onClick={submitAddDocs}
            className="addplanbutton uploadSupportDocs"
          >
            Upload
          </button>
        </footer>
      </div>
    </div>
  );
}

const mapStatetoProps = (state) => ({
  documentTypes: state.plans.documentTypes,
});

const mapDispatchtoProps = (dispatch) => {
  return {
    getDocumentTypes: () => {
      dispatch(getDocumentTypes());
    },
    fetchAdditionalDocuments: (data) => {
      dispatch(fetchAdditionalDocuments(data));
    },
  };
};

export default connect(mapStatetoProps, mapDispatchtoProps)(UploadModal);
